"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M10 3h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm2 5c-.51 0-.92.39-.98.89L13 10.86V9c0-.55-.45-1-1-1zm0-2c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C20.53 16.25 21 14.68 21 13c0-2.12-.74-4.07-1.97-5.61l.75-.75c.38-.38.39-1.01 0-1.4l-.01-.01c-.39-.39-1.01-.38-1.4 0l-.75.75C16.07 4.74 14.12 4 12 4c-1.66 0-3.22.48-4.57 1.29l1.45 1.45c.94-.47 2-.74 3.12-.74zm8.19 14.88L3.87 4.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.07 2.07C3.61 9.42 3.05 11.03 3 12.76 2.87 17.84 6.94 22 12 22c1.84 0 3.55-.55 4.98-1.5l1.79 1.79c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41zM12 20c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95z"
}), 'TimerOffRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/TimerOffRounded.js
// module id = 5709
// module chunks = 0